import React from 'react'
import Helmet from 'react-helmet'

export default function SEOPost({title, description, image, url}) {
    return (
        <>
           <Helmet>
            <html lang="en" />
            <title>{title}</title>
            <meta name="description" content={description} />
            <link rel="preload" href="/fonts/fonts.css" as="style"></link>
            <meta name="image" property="og:image" content={image} />
            <link rel="canonical" href={url} />
          </Helmet> 
        </>
    )
}
